import {POObjectNotify} from '@objects-module/model';

export class PONotifyTypes {
  static virtualInviteAccepted = POObjectNotify.virtual_typeInviteAccepted;

  static virtualTypes = [PONotifyTypes.virtualInviteAccepted];

  static baseNotifyType = 'Notify';
}
